export const SHOW_MODAL_WINDOW = "WINDOW_SHOW_MODAL_WINDOW";
export const REMOVE_MODAL_WINDOW = "WINDOW_REMOVE_MODAL_WINDOW";
export const UPDATE_MODAL_WINDOW = "WINDOW_UPDATE_MODAL_WINDOW";
export const SHOW_WINDOW = "WINDOW_SHOW_WINDOW";
export const REMOVE_WINDOW = "WINDOW_REMOVE_WINDOW";
export const FOCUS_WINDOW = "WINDOW_FOCUS_WINDOW";

export function showModalWindow(windowId, kind, payload, title="", options={}) {
  return {
    type: SHOW_MODAL_WINDOW,
    windowId, kind, payload, title, options
  }
}

export function updateModalWindow(windowId, payload, title="", options={}) {
  return {
    type: UPDATE_MODAL_WINDOW,
    windowId, payload, title, options
  }
}

export function removeModalWindow(windowId) {
  return {
    type: REMOVE_MODAL_WINDOW,
    windowId
  }
}

export function showWindow(windowId, kind, payload, title="") {
  return {
    type: SHOW_WINDOW,
    windowId, kind, payload, title
  }
}

export function removeWindow(windowId) {
  return {
    type: REMOVE_WINDOW,
    windowId
  }
}

export function focusWindow(windowId) {
  return {
    type: FOCUS_WINDOW,
    windowId
  }
}

